import ProfileAvatar from "components/common/ProfileAvatar";

// 멘션 자동완성 드롭다운. 컨테이너 기준 절대배치(placement로 above/below).
// onMouseDown+preventDefault 로 textarea blur 전에 선택을 확정한다.
const MentionDropdown = ({
  id,
  open,
  results,
  loading,
  activeIndex,
  onSelect,
  placement = "below",
}) => {
  if (!open) return null;
  return (
    <div
      id={id}
      className={`mention-dropdown mention-dropdown--${placement}`}
      role="listbox"
      aria-label="멘션 사용자 목록"
    >
      {loading && results.length === 0 && (
        <div className="mention-dropdown__status">검색 중…</div>
      )}
      {!loading && results.length === 0 && (
        <div className="mention-dropdown__status">검색 결과가 없어요</div>
      )}
      {results.map((u, i) => (
        <button
          type="button"
          key={u.user_id}
          id={id ? `${id}-opt-${i}` : undefined}
          role="option"
          aria-selected={i === activeIndex}
          className={`mention-dropdown__item${i === activeIndex ? " is-active" : ""}`}
          onMouseDown={(e) => {
            e.preventDefault();
            onSelect(u);
          }}
        >
          <ProfileAvatar imageUrl={u.profile_image} size={32} />
          <span className="mention-dropdown__nickname">{u.nickname || u.username}</span>
          {u.username && u.username !== u.nickname && (
            <span className="mention-dropdown__username">{u.username}</span>
          )}
        </button>
      ))}
    </div>
  );
};

export default MentionDropdown;
